import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { BranchService } from '../Services/branch.service';
import { CommonService } from '../Services/common.service';
import { AuthService } from '../Services/auth.service';
import { TicketService } from '../Services/ticket.service';
import { CookieService } from '../Services/cookie';

@Component({
  selector: "app-reach-us",
  templateUrl: "./reach-us.component.html",
  standalone:false,
  styleUrls: ["./reach-us.component.scss"],
})
export class ReachUsComponent implements OnInit {
  modalObservable: Subject<void> = new Subject<void>();
  ContactDEts: any;
  email: any;
  Phone: any;
  call: boolean = false;
  BranchesListDetails: any;
  QuickLinks: any;
  Instalink: any;
  LinkedInink: any;
  facebooklink: any;
  Youtubelink: any;
  emailusHeading: string;

  constructor(private router: Router, private content: BranchService, public auth: AuthService, private cookieService:CookieService,
   private Ticket: TicketService, private commonP: CommonService,) { }

  async ngOnInit(): Promise<any> {
    this.auth.accessToken = await this.commonP.Get("token");
    Promise.all([this.Contact(),this.GETQucikLinks()]);
    
  }

  branchLocator() {
    this.router.navigateByUrl("/BranchLocator");
  }
  // feedbacks() {
  //   // this.emailusHeading=""
  //   // this.router.navigateByUrl("/Feedbacks");
  //   window.location.href = "https://www.bahraincredit.com.bh/AboutUs/CustomerComplaints/ComplaintsForm/";
  // }
  feedbacks() {
    window.open("https://www.bahraincredit.com.bh/AboutUs/CustomerComplaints/ComplaintsForm/", "_blank");
}

  Contact() {

    this.commonP.presentLoading();
    this.content.Content().then((res: any) => {

      console.log('contact', res);
      if (res?.response?.code == 1) {
        this.ContactDEts = res.response.content;
        this.email = this.ContactDEts[0].email;
        this.Phone = this.ContactDEts[0].phoneNumber;
        console.log('ContactDEts', this.ContactDEts);
        this.commonP.hideLoading();


      }
      else {
        this.commonP.hideLoading();
        this.commonP.ParseErrorAlert('', 'OK', this.router, res)
      }

    })


  }
  click() {

    this.call = true;

  }


  GETQucikLinks() {

    this.commonP.presentLoading();
    this.content.GetQuickLinks().then((res: any) => {

      if (res?.response?.code == 1) {
        this.QuickLinks = res.response.content;


        this.QuickLinks.forEach(element => {
          
          if(element.title == "Youtube"){
            this.Youtubelink = element.url
            console.log('Youtube',this.Youtubelink)
          }
          else if(element.title == "Facebook"){
            this.facebooklink =  element.url
            console.log('Facebook',this.facebooklink)

          }
          else if(element.title == "LinkedIn"){
            this.LinkedInink = element.url
            console.log('LinkedInink',this.LinkedInink)

          }
          else if(element.title == "Instagram"){
            this.Instalink = element.url    
            console.log('Instagram',this.Instalink)

          }
          else{

          }
        });
        // this.Youtubelink = this.QuickLinks.filter(x=>x.title == "Youtube");
        // this.facebooklink = this.QuickLinks.filter(x=>x.title == "Facebook");
       // this.LinkedInink = this.QuickLinks.filter(x=>x.title == "LinkedIn");
        //  this.Instalink = this.QuickLinks.filter(x=>x.title == "Youtube");

        console.log('QuickLinks', this.QuickLinks);
         this.commonP.hideLoading();
      }
      else {
        this.commonP.hideLoading();
        this.commonP.ParseErrorAlert('', 'OK', this.router, res)
      }

    })


  }

  emailUs() {
    this.emailusHeading="444"

    this.cookieService.set("emailusss", this.emailusHeading,true);
    this.router.navigateByUrl("/Feedbacks");
  }

  showModal(num) {
    this.modalObservable.next(num);
  }

  logIn() {
    this.router.navigateByUrl("/LoginWithIdNum");
  }
  // signUp() {

  // }


}
